module.exports = __webpack_public_path__ + "img/bg_02.c2f9785b.png";